import React, { useState } from 'react';
import { FaChevronUp } from 'react-icons/fa';
import classNames from '../../../../utility/classNames';

export default function SectionContainer({
  children,
  label,
  description,
  toggleSection,
  defaultOpen = true,
  noHeader = false,
  id,
}) {
  const [isOpen, setIsOpen] = useState(noHeader || defaultOpen);

  return (
    <div className="w-full flex flex-col bg-white rounded-lg" id={id}>
      {!noHeader && (
        <div
          className={classNames(
            'w-full flex justify-start items-center p-5 group',
            isOpen ? 'border-b border-neutral-50 rounded-t-lg' : 'rounded-lg'
          )}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="flex items-center">
            {toggleSection && (
              <button
                type="button"
                className="text-primary text-sm font-medium flex items-center group-hover:text-primary-500"
                aria-label={isOpen ? 'Collapse' : 'Expand'}
              >
                <FaChevronUp
                  className={`transform transition ${
                    isOpen ? 'rotate-0' : 'rotate-180'
                  }`}
                />
              </button>
            )}
          </div>
          <div
            className={classNames(
              'h-full w-full flex flex-col items-start',
              toggleSection && 'pl-5'
            )}
          >
            <h2 className="text-lg font-medium font-serif text-neutral-900 tracking-wider">
              {label}
            </h2>
            {description && (
              <p className="text-md text-neutral-500">{description}</p>
            )}
          </div>
        </div>
      )}
      {isOpen && (
        <div className="px-5 py-[22px] flex flex-col space-y-4 relative">
          {children}
        </div>
      )}
    </div>
  );
}
